"use client"

// src/components/loading.ts
var Loading = {
  baseStyle: ({ colorScheme: c }) => ({
    color: [`${c}.500`, `${c}.600`]
  }),
  defaultProps: {
    colorScheme: "primary",
    size: "1em",
    variant: "oval"
  }
};

export {
  Loading
};
//# sourceMappingURL=chunk-67JW5AXD.mjs.map